var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsDonation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4262.000000, -833.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Donation",
    transform: "translate(4262.000000, 833.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5815065,21.0542143 L17.2887299,7.43207143 L17.1337323,7.29092857 L24.4596178,5.98071429 C26.1545913,5.72535714 27.8525648,4.6445 27.8525648,3 L8.8128623,3 C3.94693833,3 0,6.60842857 0,11.0581429 C0,12.7342143 0.55999125,14.2914286 1.51797628,15.5802857 C1.727973,15.9145714 1.98096905,16.2321429 2.29296417,16.5172143 L15.9727504,28.3305 C16.4897423,28.7994286 17.3317292,28.7994286 17.8527211,28.3305 C18.3717129,27.8643571 18.3717129,27.1057143 17.8527211,26.6405 L13.6517867,22.4182857 C14.0677802,22.2483571 14.464774,22.0264286 14.8407681,21.7608571 L22.8936423,28.649 C23.4036343,29.117 24.2346213,29.117 24.7486133,28.649 C25.2606053,28.181 25.2606053,27.4195714 24.7486133,26.9525 L17.2497305,19.6260714 L18.1487164,18.8024286 L28.2745582,27.5152143 C28.7725504,27.9692857 29.5765379,27.9720714 30.0715301,27.5152143 C30.5665224,27.0639286 30.5665224,26.3303571 30.0715301,25.8744286 L20.5026796,16.5794286 C20.7656755,16.2702143 20.9836721,15.9433571 21.1596694,15.6035 L29.5605381,22.8992857 C30.1195294,23.4090714 31.0225153,23.4090714 31.5815065,22.8992857 C32.1394978,22.3885714 32.1394978,21.5630714 31.5815065,21.0542143",
    id: 99
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsDonation);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-donation.c06fbd61.svg";
export { ForwardRef as ReactComponent };